import { render, staticRenderFns } from "./UpdateCacheMessage.vue?vue&type=template&id=672cc094&scoped=true"
import script from "./UpdateCacheMessage.vue?vue&type=script&lang=js"
export * from "./UpdateCacheMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672cc094",
  null
  
)

export default component.exports